import { render, staticRenderFns } from "./admin-returns.vue?vue&type=template&id=1eff1ee7&scoped=true"
import script from "./admin-returns.vue?vue&type=script&lang=js"
export * from "./admin-returns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff1ee7",
  null
  
)

export default component.exports